import styled, { css } from 'styled-components';

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  ${(props) =>
    !props.isOpen &&
    css`
      visibility: hidden;
    `}
`;

export const ModalContainer = styled.div`
  background-color: #fff;
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform: translate(-50%, 50%);
  width: 70%;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 90%;
  overflow-y: auto;
  border-radius: 0px !important;
`;

export const ModalTitle = styled.h2`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  color: #fff;
  font-size: 1rem;
  height: 55px;
  line-height: 55px;
  overflow: hidden;
  background: #297fb8;
  padding-left: 20px;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
`;

export const CloseButton = styled.button`
  position: absolute;
  width: 18px;
  height: 18px;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: calc(50% - 1px);
    width: 2px;
    height: 18px;
    background: #333;
  }
  &:before {
    transform: rotate(-45deg);
  }
  &:after {
    transform: rotate(45deg);
  }
`;

export const ItemInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;

export const ItemIcon = styled.img`
  margin: 25px 0 18px;
  width: 101px;
  height: 101px;
  object-fit: contain;
`;

export const ItemName = styled.div`
  font-size: 18px;
  line-height: 17px;
  font-weight: 600;
  color: #222;
  text-align: center;
`;

export const ItemEffect = styled.div`
  font-size: 12px;
  color: #1aa718;
  line-height: 12px;
  margin-top: 12px;
  text-align: center;
`;

export const QuantitySection = styled.div`
  width: 100%;
  margin-top: 20px;
  border-top: #ececec solid 1px;
`;

export const QuantityRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-bottom: #ececec solid 1px;
  
  &:last-of-type {
    border-bottom: none;
  }
`;

export const QuantityLabel = styled.div`
  font-size: 13px;
  color: #222;
  font-weight: bold;
`;

export const QuantityValue = styled.div`
  font-size: 13px;
  color: #222;
  font-weight: bold;
`;

export const QuantityControlGroup = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-left: auto;
`;

export const Count = styled.div`
  min-width: 50px;
  height: 28px;
  border: 1px solid #e4e4e4;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-weight: 600;
    font-size: 16px;
  }
`;

export const ButtonQuantity = styled.div`
  width: 12px;
  height: 12px;
  cursor: pointer;
  background-size: 12px 12px;
  background-repeat: no-repeat;
  
  &.POINT.minus {
    background-image: url('/images/market/minus-POINT.png');
  }
  &.GOLD.minus {
    background-image: url('/images/market/minus-GOLD.png');
  }
  &.MEDAL.minus {
    background-image: url('/images/market/minus-MEDAL.png');
  }
  &.POINT.plus {
    background-image: url('/images/market/plus-POINT.png');
  }
  &.GOLD.plus {
    background-image: url('/images/market/plus-GOLD.png');
  }
  &.MEDAL.plus {
    background-image: url('/images/market/plus-MEDAL.png');
  }
  ${({ disabled }) => disabled && `opacity: 0.3; cursor: not-allowed;`}
`;

export const DecrementButton = styled(ButtonQuantity)``;

export const IncrementButton = styled(ButtonQuantity)``;

export const QuantityInput = styled.input`
  display: none;
`;

export const AllButton = styled.button`
  padding: 6px 12px;
  margin-left: 8px;
  border: none;
  background-color: #297fb8;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  
  &:hover {
    background-color: #1f5f8f;
  }
`;

export const TotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-top: #ececec solid 1px;
`;

export const TotalLabel = styled.div`
  font-size: 13px;
  color: #222;
  font-weight: bold;
`;

export const TotalValue = styled.div`
  font-size: 13px;
  color: #222;
  font-weight: bold;
  text-align: right;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const TotalItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const PointIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  background-color: #1287eb;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
  
  &:before {
    content: "P";
  }
`;

export const CashIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 0%;
  flex-shrink: 0;
  
  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: url(/images/market/icon_medal.png) no-repeat;
    background-size: contain;
  }
`;

export const ExpIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  background-color: #5d00c5;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
  &:before {
    content: "E";
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  gap: 10px;
`;

export const CancelButton = styled.button`
  height: 44px;
  width: 100%;
  line-height: 44px;
  border: none;
  color: #fff;
  background-color: #8e8e8e;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const UseButton = styled.button`
  height: 44px;
  width: 100%;
  line-height: 44px;
  border: none;
  color: #fff;
  background-color: #ed2026;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

